module.exports = __webpack_public_path__ + "static/img/streamMedia-whyneed-img1.b4a7a8b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/streamMedia-whyneed-img1.png
// module id = 1094
// module chunks = 1